module.exports = __webpack_public_path__ + "static/media/success.2e545da6.png";